import { Switch } from "@heroui/react";

import { useUpdateDirection } from "@/features/directions/use-directions.ts";

export function ToggleDirectionStatus({
  id,
  defaultSelected,
  fromCityId,
  toCityId,
}: {
  id: number;
  fromCityId: number;
  toCityId: number;
  defaultSelected?: boolean;
}) {
  const updateRoute = useUpdateDirection({});

  return (
    <Switch
      defaultSelected={defaultSelected}
      onChange={(isActive) =>
        updateRoute.mutateAsync({ id, isActive, fromCityId, toCityId })
      }
    >
      <Switch.Control>
        <Switch.Thumb />
      </Switch.Control>
    </Switch>
  );
}
